import { useMemo } from "react";
import { MaterialTransferido } from "../interfaces";
import { MRT_ColumnDef } from "material-react-table";

import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import CustomCantidadInput from "../components/ui/CustomCantidadInput";
import { Delete } from "@mui/icons-material";

import {Chip, IconButton, Tooltip } from "@mui/material";

export const useTableColumnsSolicitudEgreso = () => {
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleEliminarProdcuto = useCargarSeriesProductos(s => s.handleEliminarProducto)


  const columnsInfoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'Codigo'
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción'
    },
    {
      accessorKey: 'producto_data.unidad_medida',
      header: 'Unidad Medida',
      Cell: ({ row }) => {
        return  <Chip
          label={row.original?.producto_data?.unidad_medida || "-"}
          sx={{backgroundColor:'#ccdfcc'}}
        />
      }
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      Cell: ({ row }) => row.original?.producto_data?.categoria_producto || 'N/A'
    },
    {
      accessorKey: 'producto_data.modelo_producto',
      header: 'Modelo',
      Cell: ({ row }) => row.original?.producto_data?.modelo_producto || 'N/A'
    }
  ], [])
  const columnsSolicitudEgreso = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => {
        return (
          <Tooltip title="Eliminar">
            <IconButton
              onClick={() => {
                handleEliminarProdcuto(row.original.id)
              }}
            >
              <Delete color="error" />
            </IconButton>

          </Tooltip>

        )
      }
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad Requerida',
      size: 190,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      )
    },


    ...columnsInfoProducto
  ], [])
  return {
    columnsSolicitudEgreso
  }
}
export default useTableColumnsSolicitudEgreso;